import { twMerge } from "tailwind-merge";

type TableContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  fillHeight?: boolean;
};

export const TableContainer = ({ className, fillHeight = false, ...rest }: TableContainerProps) => {
  return (
    <div
      className={twMerge(
        "relative flex min-h-0 flex-col gap-4 mb-6",
        fillHeight && "mb-0 min-w-0 flex-1",
        className,
      )}
      {...rest}
    />
  );
};
